<template>
  <modal back="edit-upload" :title="$t('customization.changeImageEffect')">
    <collection
      :designs="computedEffects"
      @item-clicked="closeModalAfter(() => selectEffect($event))"
    />
  </modal>
</template>

<script>
import Modal from '../../components/Modal.vue';
import Collection from '../../components/CollectionGrid.vue';
import { CREATOR_BASE_URL } from '../../../utils/configure-environment';
import Redirect from '@/mixins/redirect';
import ActiveElement from '@/mixins/activeElement';

const loadImg = src =>
  `${CREATOR_BASE_URL}/${require.context(
    '../../assets/effects/',
    false,
    /\.webp/
  )(`./${src}`)}`;

export default {
  name: 'UploadDesignEffectChange',
  components: {
    Modal,
    Collection
  },
  mixins: [Redirect, ActiveElement],
  data() {
    return {
      effects: [
        {
          id: 0,
          thumbnail: loadImg('normal.webp')
          // thumbnail: CREATOR_BASE_URL + '/' + thumbnailContext('/normal.webp')
        },
        // {
        //   id: 8,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./paper_torn.webp'),
        //   config: {
        //     xp: 10,
        //     yp: 10
        //   }
        // },
        // {
        //   id: 7,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./soft_edge.webp'),
        //   config: {
        //     sigma: 100
        //   }
        // },
        {
          id: 9,
          thumbnail: loadImg('rounded.webp'),
          config: {
            radiusp: 10
          }
        },
        {
          id: 10,
          thumbnail: loadImg('contrast_default.webp'),
          config: {
            contrast: 20,
            brightness: 20
          }
        },
        {
          id: 10,
          thumbnail: loadImg('contrast_low_brightness.webp'),
          config: {
            contrast: 40,
            brightness: -5
          }
        },
        {
          id: 11,
          thumbnail: loadImg('invert_blue.webp'),
          config: {
            channel: 2
          }
        },
        {
          id: 11,
          thumbnail: loadImg('invert_red.webp'),
          config: {
            channel: 3
          }
        },
        {
          id: 11,
          thumbnail: loadImg('invert_yellow.webp'),
          config: {
            channel: 4
          }
        },
        {
          id: 11,
          thumbnail: loadImg('invert_black.webp'),
          config: {
            channel: 5
          }
        },
        {
          id: 12,
          thumbnail: loadImg('grayscale_light.webp'),
          config: {
            channel: 2
          }
        },
        {
          id: 12,
          thumbnail: loadImg('grayscale_medium.webp'),
          config: {
            channel: 3
          }
        },
        {
          id: 12,
          thumbnail: loadImg('grayscale_high.webp'),
          config: {
            channel: 4
          }
        },
        {
          id: 1,
          thumbnail: loadImg('vignette.webp'),
          config: {
            xp: 1,
            yp: 1
          }
        },
        // {
        //   id: 2,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./oilpaint.webp'),
        //   config: {
        //     radius: 20
        //   }
        // },
        // {
        //   id: 3,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./charcoal_dark.webp'),
        //   config: {
        //     sigma: 0
        //   }
        // },
        // {
        //   id: 3,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./charcoal_light.webp'),
        //   config: {
        //     sigma: 16
        //   }
        // },
        // {
        //   id: 3,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./charcoal_bold.webp'),
        //   config: {
        //     sigma: 30
        //   }
        // },
        // {
        //   id: 4,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./edge_soft.webp'),
        //   config: {
        //     radius: 5
        //   }
        // },
        // {
        //   id: 4,
        //   thumbnail:
        //     CREATOR_BASE_URL + '/' + thumbnailContext('./edge_sharp.webp'),
        //   config: {
        //     radius: 10
        //   }
        // },
        {
          id: 5,
          thumbnail: loadImg('equalize.webp')
        }
      ]
    };
  },
  computed: {
    computedEffects() {
      return this.effects.map(effect => ({
        ...effect,
        selected:
          this.activeElement.effect === effect.id &&
          JSON.stringify(this.activeElement.config || {}) ===
            JSON.stringify(effect.config || {})
      }));
    }
  },
  methods: {
    selectEffect(effect) {
      this.updateElement({
        effect: effect.id,
        config: effect.config || {}
      });
    }
  }
};
</script>
